import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Order, OrderLines } from '@features/user/interfaces/order.interface';
import { OrderService } from '@features/user/services/order.service';
import {
  faChevronDown,
  faChevronRight,
  faChevronUp,
  faSearch,
  faSpinner,
} from '@fortawesome/free-solid-svg-icons';
import { FilterOperator } from '@shared/enums/common.enum';
import { Filter } from '@shared/interfaces/common.interface';
import { LayoutService } from 'src/app/layout/services/layout.service';
import { SwiperOptions } from 'swiper';

@Component({
  selector: 'fc-user-order',
  templateUrl: './user-order.component.html',
  styleUrls: ['./user-order.component.css'],
})
export class UserOrderComponent implements OnInit, OnDestroy {
  faSearch = faSearch;
  faSpinner = faSpinner;
  faChevronDown = faChevronDown;
  faChevronUp = faChevronUp;
  faChevronRight = faChevronRight;

  shopDefaultImg = 'assets/images/shop/default-shop-logo.webp';
  productDefaultImg: string = 'assets/images/product/default-product.png';

  activeStatus: any = 'all';
  hideLoadMore = true;
  loadMoreLoading = false;
  currentPage = 0;
  filters: Filter[] = [];
  totalItems: number = 0;
  orders: Order[] = [] as Order[];
  pToggle: any = [];

  // swiper
  config: SwiperOptions = {
    slidesPerView: 5,
    spaceBetween: 5,
    loop: true,
    pagination: {
      type: 'fraction',
    },
  };
  dateFilter = null;

  constructor(
    private route: ActivatedRoute,
    private orderService: OrderService,
    private layoutService: LayoutService
  ) {
    this.route.data.subscribe((data: any) => {
      this.activeStatus = data.status || 'all';
      if (this.activeStatus != 'all')
        this.filters = [
          {
            field: 'orders.status',
            operator: FilterOperator.equal,
            value: this.activeStatus,
          },
        ];
    });
    if (this.layoutService.isMobile$.value) {
      this.layoutService.setFooterVisibility(false);
      this.layoutService.setMobileLayoutConfig({
        headerNav: {
          backButton: true,
          title: 'Order List',
          searchButton: false,
        },
        bottomNav: {
          visibillity: false,
        },
      });
    }
  }
  ngOnDestroy(): void {
    if (this.layoutService.isMobile$.value) {
      this.layoutService.setFooterVisibility(true);
      this.layoutService.setDefaultMobileLayoutConfig();
    }
  }

  handleShopImgError() {
    this.shopDefaultImg = 'assets/images/shop/default-shop-logo.webp';
  }
  handleProductImgError() {
    this.productDefaultImg = 'assets/images/product/default-product.png';
  }

  ngOnInit(): void {
    this.loadOrders();
  }

  loadOrders() {
    this.currentPage += 1;
    if (!this.loadMoreLoading) {
      this.loadMoreLoading = true;
      this.orderService
        .getOrders(5, this.currentPage, this.dateFilter, this.filters)
        .subscribe(
          (data) => {
            this.totalItems = data.totalItems;
            data.orders.forEach((x) => this.orders.push(x));
            data.orders.map((x) => this.pToggle.push(false));
            this.loadMoreLoading = false;
            if (this.orders.length >= data.totalItems) this.hideLoadMore = true;
          },
          (error) => {
            this.loadMoreLoading = false;
          }
        );
    }
  }

  onPToggle(i: any) {
    if (this.pToggle[i] == true) {
      for (let index in this.pToggle) {
        this.pToggle[index] = false;
      }
    } else {
      for (let index in this.pToggle) {
        this.pToggle[index] = false;
      }
      this.pToggle[i] = true;
    }
  }

  setDateFilter(date: any) {
    this.dateFilter = date;
    this.orders = [];
    this.hideLoadMore = false;
    this.currentPage = 0;
    this.loadOrders();
  }

  translateOrderStatus(status: number) {
    return this.orderService.translateOrderStatus(status);
  }

  openBuyAgainModal(shopName: string, lines: OrderLines[]) {
    this.orderService.setbuyAgainOrderState(shopName, lines);
  }
}
